import axios from "axios";

const Url = process.env.REACT_APP_URl;

export const GenerateDescTitleServ = async (processid: any, property: any) => {
    const data: any = {
        desc: [],
        title: []
    };

    for (let index = 0; index < property.lang.length; index++) {
        const lang = property.lang[index];
        try {
            const [titleResponse, descResponse] = await Promise.all([
                axios.post(Url + "/generate-title", {
                    processid: processid,
                    data: property,
                    lang: lang
                }, {
                    headers: {
                        
                        "Authorization": "Bearer " + localStorage.getItem("usertoken")
                    }
                }),
                axios.post(Url + "/generate-description", {
                    processid: processid,
                    data: property,
                    lang: lang
                }, {
                    headers: {
                        
                        "Authorization": "Bearer " + localStorage.getItem("usertoken")
                    }
                })
            ]);
            data.desc.push({
                lang: lang,
                desc: descResponse.data.data.result
            });
            data.title.push({
                lang: lang,
                title: titleResponse.data.data.result
            });
        } catch (error) {
            console.error(`Error during generation for language ${lang}:`, error);
        }
    }

    return data;
};

export const GenerateDescServ = async (processid: any, property: any, lang: string) => {
    const response = await axios.post(Url + "/generate-description", {
        processid: processid,
        data: property,
        lang: lang
    }, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data
}

export const GenerateTitleServ = async (processid: any, property: any, lang: string) => {
    const response = await axios.post(Url + "/generate-title", {
        processid: processid,
        data: property,
        lang: lang
    }, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data
}

export const SaveTemplateServ = async (obj: any) => {
    const response = await axios.post(Url + "/templates", obj, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data
}

export const GetTemplateServ = async () => {
    const response = await axios.get(Url + "/templates", {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data
}


export const GenerateRoomImage = async (generateObj: any) => {
    const apiUrl = Url + "/roomgenerate";
    const response = await axios.post(apiUrl, generateObj, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GenerateQRCodeService = async (generateObj: any) => {
    const apiUrl = Url + "/generate_QR";
    const response = await axios.post(apiUrl, generateObj, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const checkFurnitureInRoom = async (imageObj: any) => {
    const response = await axios.post(Url + "/detect_furnished_unfurnished", {
        "data": [
            imageObj
        ]
    }, {
        headers: {
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}